import { ReactNode, createContext, useContext } from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { SelectOption } from "shared/types/Select"
import { AttachmentType } from "shared/types/__generated__/graphql"

export interface ProductPositionFormAttachmentsContextType {
  attachments: AttachmentType[] | null
  linkedAttachments: AttachmentType[] | null
  attachmentCategories: SelectOption<string>[] | null

  onUpload?: (
    file: FilePreview,
    category: string
  ) => Promise<ApiResponse<AttachmentType>> | void
}

const ProductPositionFormAttachmentsContext =
  createContext<ProductPositionFormAttachmentsContextType | null>(null)

export interface ProductPositionFormAttachmentsProviderProps {
  value: ProductPositionFormAttachmentsContextType
  children: ReactNode
}

export function ProductPositionFormAttachmentsProvider({
  value,
  children
}: ProductPositionFormAttachmentsProviderProps) {
  return (
    <ProductPositionFormAttachmentsContext.Provider value={value}>
      {children}
    </ProductPositionFormAttachmentsContext.Provider>
  )
}

export function useProductPositionFormAttachmentsContext() {
  const context = useContext(ProductPositionFormAttachmentsContext)

  if (!context) {
    throw new Error(
      "useProductPositionFormAttachments must be used within ProductPositionFormAttachmentsProvider"
    )
  }

  return context
}
